var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.82 145.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ca5ad;}.cls-2{fill:#505050;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,.3A47.39,47.39,0,0,0,18.44,84.9c4.4,3.41,7.14,3.57,7.14,19.64v.26a5.24,5.24,0,0,1,1.59-.25H67.65a5.19,5.19,0,0,1,1.59.25v-.3c0-15.56,2.77-16.21,7.17-19.62A47.4,47.4,0,0,0,42,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.72,73.4H51.1v31.14h4V73.4H61a9.86,9.86,0,1,0-9.86-9.85v5.84H43.72V63.55a9.86,9.86,0,1,0-9.86,9.85H39.7v31.14h4Zm11.4-9.85A5.84,5.84,0,1,1,61,69.39H55.12ZM39.7,69.39H33.86a5.84,5.84,0,1,1,5.84-5.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.94,
    y: 104.6,
    width: 56.94,
    height: 40.97,
    rx: 2.95
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.2db70435ab5157ef335384edab7bcc7e.svg";
export { ForwardRef as ReactComponent };